import { useEffect, useMemo, useRef } from 'react'
import { useDashboardStore } from '@/state/useDashboardStore'
import { useTrophyStore } from '@/state/useTrophyStore'
import { useTenant } from '@/tenant/TenantProvider'
import { DEFAULT_MILESTONES } from './definitions'
import { detectMilestones } from './detector'
import { appBus } from '@/lib/eventBus'
import type { DashboardSnapshot } from '@/data/types'

export function MilestoneDetector() {
  const tenant = useTenant()
  const defs = useMemo(
    () =>
      (tenant.milestones.defaultsEnabled ? DEFAULT_MILESTONES : []).concat(
        tenant.milestones.customDefinitions ?? [],
      ),
    [tenant],
  )
  const prevRef = useRef<DashboardSnapshot | null>(null)

  const bumpCounter = useDashboardStore((s) => s.bumpCounter)
  const snapshot = useDashboardStore((s) => s.snapshot)
  const unlockMany = useTrophyStore((s) => s.unlockMany)
  const unlocked = useTrophyStore((s) => s.unlocked)

  useEffect(() => {
    if (!snapshot) return
    const already = new Set(unlocked.map((u) => u.milestoneId))
    const newlyHit = detectMilestones(defs, prevRef.current, snapshot, already)
    if (newlyHit.length > 0) {
      const created = unlockMany(newlyHit)
      created.forEach((t) => appBus.emit('trophy-unlocked', t))
    }
    prevRef.current = structuredClone(snapshot)
  }, [bumpCounter, snapshot, defs, unlockMany, unlocked])

  return null
}
